import {
  useCompositeStoreOptions,
  useCompositeStoreProps
} from "../__chunks/7KULBIZY.js";
import "../__chunks/RS7KBRGA.js";
import {
  usePopoverStoreOptions,
  usePopoverStoreProps
} from "../__chunks/3PKTK2K7.js";
import "../__chunks/WC3GK4CL.js";
import "../__chunks/SWJ5EOOS.js";
import {
  useStore,
  useStoreProps
} from "../__chunks/P63NRZ4A.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/select/select-store.ts
import * as Core from "@ariakit/core/select/select-store";
function useSelectStoreOptions(props) {
  return __spreadValues(__spreadValues({}, useCompositeStoreOptions(props)), usePopoverStoreOptions(props));
}
function useSelectStoreProps(store, props) {
  store = useCompositeStoreProps(store, props);
  store = usePopoverStoreProps(store, props);
  useStoreProps(store, props, "value", "setValue");
  return store;
}
function useSelectStore(props = {}) {
  const options = useSelectStoreOptions(props);
  const store = useStore(
    () => Core.createSelectStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useSelectStoreProps(store, props);
}
export {
  useSelectStore,
  useSelectStoreOptions,
  useSelectStoreProps
};
